import axios from "axios";
import { baseUrl, portal } from "../App";
import { logEvent } from "../helper/gaEvent";

export const fetchSubscriptionUrl = async (token, service_type) => {
  const searchParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(searchParams);
  let currency = "BDT";
  let price = 30;
  if(service_type === "Tournament"){
    price = 40;
  }

  const config = {
    headers: { Authorization: `Token ${token}` },
  };

  const res = await axios
    .post(
      `${baseUrl}/subscription/create/`,
      { portal: portal, qcid: sessionStorage.getItem("cid"), "service_type": service_type, ...paramsObject },
      config
    )
    localStorage.setItem("subscription_checkout", JSON.stringify({ serviceType: service_type, time: Date.now() }));
    logEvent("begin_checkout",{
      service_type: service_type,
      currency: currency,
      price: price,
    });
  return res.data;
}